<template>
  <path
    d="M12.625 7.11464C12.625 7.72317 12.0861 8.19062 11.4836 8.1046L10.4502 7.95703C7.83776 7.58383 5.5 9.61104 5.5 12.25C5.5 14.889 7.83776 16.9162 10.4502 16.543L11.4832 16.395C12.0858 16.3087 12.625 16.7762 12.625 17.3849V20C12.625 20.5523 12.1773 21 11.625 21H4.125C3.57272 21 3.125 20.5523 3.125 20V4C3.125 3.44772 3.57272 3 4.125 3H11.625C12.1773 3 12.625 3.44772 12.625 4V7.11464Z"
    fill="currentColor"
  />
  <path
    class="puzzle-right"
    d="M20.875 20C20.875 20.5523 20.4273 21 19.875 21H14.875C14.3227 21 13.875 20.5523 13.875 20V15.6046C13.875 14.9569 13.2687 14.4801 12.6393 14.6327L10.6621 15.1123C8.79667 15.5644 7 14.1509 7 12.2314C7.00014 10.1748 9.04365 8.74358 10.9766 9.44629L12.5336 10.0118C13.1857 10.2487 13.875 9.7657 13.875 9.0719V4C13.875 3.44772 14.3227 3 14.875 3H19.875C20.4273 3 20.875 3.44772 20.875 4V20Z"
    fill="currentColor"
    fill-rule="evenodd"
  />
</template>
